import { cartStepsPayload } from './cartStepsPayload';

export const cartStepContinueToPayment = () => cartStepsPayload('continuar-para-pagamento');
